<div class="_flex _flex-col _h-full _max-h-[90vh]">
    <div class="_flex _justify-between _pb-3 _border-b _border-transparency-black-5 _shadow-bottom">
        <div class="_text-h4 sm:_text-h3 _heading">Product Finder</div>
        <i class="fa-light fa-xmark _cursor-pointer" mat-dialog-close></i>
    </div>

    <mat-dialog-content class="_flex-1 _min-h-0 _overflow-y-scroll _scrollbar _scrollbar-thin _scrollbar-track-gray-100 _scrollbar-thumb-gray-300 _pr-4">
        <div class="_py-8">
            <form [formGroup]="contactForm" *ngIf="!submitSuccess && !submitError">
       
                <app-form-text-area
                    label="Brief description of your requirements"
                    placeholderText="6-bedroom villa in the Algarve with a private pool and ocean views."
                    minHeight="120px"
                    fieldId="requirementsDescription">
                </app-form-text-area>

                <div class="_flex _flex-col sm:_flex-row _gap-2 _w-full">
                    <div class="_w-full sm:_w-1/2">
                        <app-form-input-text
                        label="Estimated number of guests"
                        placeholderText="Enter number of guests."
                        fieldId="numberOfGuests"
                        [numbersOnly]="true">
                    </app-form-input-text>
                    </div>
                    <div class="_w-full sm:_w-1/2">
                        <app-form-input-text
                        [label]="'Trip budget in ' + currency"
                        placeholderText="Enter your trip budget."
                        fieldId="tripBudget"
                        [numbersOnly]="true">
                    </app-form-input-text>
                    </div>
                </div>
            
                <div class="_flex _flex-col _gap-1 _w-full _mb-4">
                    <label class="_ml-2 _text-md">Travel dates</label>
                    <app-datepicker 
                        [inline]="true"
                        id="inquiry-dates"
                        [calendarSmall]="!mobileView"
                        inputStyle="squared"
                        (newDateSearch)="updateTravelDates($event)">
                    </app-datepicker>
                </div>

                <div class="_flex _flex-col _gap-2">
                    <label class="_text-md">How would you like us to contact you? *</label>
                    <div class="_flex _flex-col _gap-1">
                        <app-form-radio-btn
                            groupName="contactMethod"
                            fieldId="contact-method-phone"
                            value="phone"
                            [checked]="true">
                            By phone
                        </app-form-radio-btn>
                        <app-form-radio-btn
                            groupName="contactMethod"
                            fieldId="contact-method-email"
                            value="email">
                            By email
                        </app-form-radio-btn>
                    </div>
                </div>
            </form>

            <div class="_py-10" *ngIf="submitSuccess">
                <div class="_h4 _pb-4">
                    <i class="fa-regular fa-sharp fa-circle-check _text-green-600 _mr-1"></i>
                    Thank you for submitting your requirements.
                </div>
                <div>We will get back to within 48 hours.</div>
            </div>

            <div class="_py-10" *ngIf="submitError">
                <div class="_h4 _pb-4">
                    <i class="fa-regular fa-sharp fa-circle-xmark _text-error-red _mr-1"></i>
                    Something went wrong with your inquiry.
                </div>
                <div>Please try again.</div>
            </div>
        </div>
    </mat-dialog-content>

    <div class="_mt-auto _bg-white _flex _flex-col xs:_flex-row _justify-end _gap-2 _p-4 _pb-0 _border-t _border-gray-200">
        <app-button
            *ngIf="!submitSuccess && !submitError"
            class="_w-full xs:_w-max"
            modifierClassNames="_w-full"
            type="primary"
            [onClick]="onSubmit.bind(this)"
            [disabled]="!formIsValid"
            [loading]="submitting">
            Submit
        </app-button>

        <app-button
            mat-dialog-close
            *ngIf="submitSuccess || submitError"
            class="_w-full xs:_w-max"
            modifierClassNames="_w-full"
            type="primary">
            Close
        </app-button>
    </div>
</div>
